import { render, staticRenderFns } from "./profile-info-card.vue?vue&type=template&id=e7e37ef0"
import script from "./profile-info-card.vue?vue&type=script&lang=js"
export * from "./profile-info-card.vue?vue&type=script&lang=js"
import style0 from "./profile-info-card.vue?vue&type=style&index=0&id=e7e37ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports